import { render, staticRenderFns } from "./ForestTable.vue?vue&type=template&id=3d2bb10a&scoped=true&"
import script from "./ForestTable.vue?vue&type=script&lang=js&"
export * from "./ForestTable.vue?vue&type=script&lang=js&"
import style0 from "./ForestTable.vue?vue&type=style&index=0&id=3d2bb10a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2bb10a",
  null
  
)

export default component.exports